import { Button, Modal, notification } from 'antd'
import React, { useState } from 'react'

import { getEnvironmentHost } from '../../../util/environment'
import { httpClient } from '../../../util/http-client'
import { messages } from '../messages'
import { Tenant } from '../models'

const buildDeleteTenantMessage = (tenant: Tenant) =>
  `Are you sure that you want to delete this tenant?\n
  - ID: ${tenant.id}\n
  - Name: ${tenant.name}\n
  - Domain: ${getEnvironmentHost({ domain: tenant.domain })}\n
  It cannot be reverted`

interface DeleteTradeProps {
  tenant: Tenant
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeleteTenantModal = ({ tenant, isVisible, onClose, onSuccess }: DeleteTradeProps) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (tradeId: number) => {
    setIsDeleting(true)

    try {
      await httpClient(`/tenants/${tradeId}`, { method: 'DELETE' })
      notification.success({ message: messages.common.success, description: messages.tenant.delete.success })
      onSuccess()
    } catch (error) {
      notification.error({
        message: messages.common.error,
        description: error.error_message || messages.tenant.delete.error,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete Tenant"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => onDelete(tenant.id)} disabled={isDeleting} loading={isDeleting} type="primary" danger>
            Delete Tenant
          </Button>
        </div>,
      ]}
    >
      {tenant && buildDeleteTenantMessage(tenant)}
    </Modal>
  )
}
